<template>
  <div class="injury_grade">
    <div
      v-for="(item, index) in gradeList"
      :key="index"
      class="injury_grade_item"
      :style="`width: ${index == gradeNum ? '18px' : '14px'};
                height:${index == gradeNum ? '18px' : '4px'};
                background: linear-gradient(to right, ${item[0]}, ${item[1]});
                transform: skew(-10deg);
            `"
    >
      <span class="item_title" v-if="index == gradeNum">{{ grade }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    grade: {
      type: [Number, String],
      default: () => 0,
    },
    gradeList: {
      type: Array,
      default: () => [
        ["#73FF9A", "#9BF092"],
        ["#B9E58B", "#F1D080"],
        ["#FFCB7C", "#FF985D"],
        ["#FF8653", "#FF4329"],
        ["#D90101", "#D90101"],
      ],
    },
  },
  computed: {
    gradeNum() {
      return this.grade - 1;
    },
  },
};
</script>
<style scoped lang="scss">
.injury_grade {
  display: flex;
  height: 18px;
  flex-direction: row;
  align-items: center;
}
.injury_grade_item {
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.item_title {
  font-family: AkrobatMedium;
  font-size: 16px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  flex-shrink: 0;
}
</style>